<template>
	<a :key="tag.name"
	          class="tag shimmer-child"
	          :href="displayTagsStatus ? `/server-tags/${tag.urlname}` : null"
	          :aria-disabled="!displayTagsStatus"
	          @click.prevent="loadTag"
	>
		{{ tag.name }}
	</a>
</template>

<script setup>
const props = defineProps({
	tag: {
		type: Object,
	},
})

const {displayTagsStatus} = useTags();

// Stupid helper to calculate text width
const widths = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.2796875,0.2765625,0.3546875,0.5546875,0.5546875,0.8890625,0.665625,0.190625,0.3328125,0.3328125,0.3890625,0.5828125,0.2765625,0.3328125,0.2765625,0.3015625,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.2765625,0.2765625,0.584375,0.5828125,0.584375,0.5546875,1.0140625,0.665625,0.665625,0.721875,0.721875,0.665625,0.609375,0.7765625,0.721875,0.2765625,0.5,0.665625,0.5546875,0.8328125,0.721875,0.7765625,0.665625,0.7765625,0.721875,0.665625,0.609375,0.721875,0.665625,0.94375,0.665625,0.665625,0.609375,0.2765625,0.3546875,0.2765625,0.4765625,0.5546875,0.3328125,0.5546875,0.5546875,0.5,0.5546875,0.5546875,0.2765625,0.5546875,0.5546875,0.221875,0.240625,0.5,0.221875,0.8328125,0.5546875,0.5546875,0.5546875,0.5546875,0.3328125,0.5,0.2765625,0.5546875,0.5,0.721875,0.5,0.5,0.5,0.3546875,0.259375,0.353125,0.5890625]
const avg = 0.5279276315789471

function measureText(str, fontSize) {
  return Array.from(str).reduce(
    (acc, cur) => acc + (widths[cur.charCodeAt(0)] ?? avg), 0
  ) * fontSize
}

const tagWidth = computed(() => measureText(props.tag.name, 20) + "px");

const loadTag = () => {
  displayTagsStatus.value = false;
  setTimeout(() => {
	navigateTo(`/server-tags/${props.tag.urlname}`);
  }, 20);
}
</script>

<style lang="scss" scoped>
.tag {
  width: v-bind(tagWidth);
  font-size: .9rem;
  color: #222;
  min-height: 1.8em;
  border: none !important;
}
</style>
